export const renderUrlParam = (key, value) => {
  let textValue = '';
  if (Array.isArray(value)) {
    textValue = value.map(val => encodeURIComponent(`${val}`)).join(',');
  } else {
    textValue = encodeURIComponent(`${value}`);
  }
  return `${encodeURIComponent(`${key}`)}=${textValue}`;
};
